import { postUpdateOrganization } from '../api/postUpdateOrganization';
import { setGetListOrganization } from './setGetListOrganization';

const setPostUpdateOrganization = (params) => {
    return async (dispatch, getState) => {
        try {
            await postUpdateOrganization(params);
            dispatch(setGetListOrganization({
                search: ''
            }));
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostUpdateOrganization
}